import React from "react";

import { Collapse } from "antd";
import { DatePicker } from 'antd';

const { Panel } = Collapse;
// const text = `
// hey
// `;



const onChange = (date, dateString) => {
  console.log(date, dateString);
};

const licenceDetail = () => {
  return (
    <Collapse defaultActiveKey={["1"]} ghost>
      <Panel header="Name" key="1">
        <input className="sub-detail" type="text" placeholder="licence name" />
      </Panel>
      <Panel header="Date of Birth" key="2">
        <DatePicker className="date-picker" onChange={onChange} />
      </Panel>
      <Panel header="Driver Licence Number" key="3">
      <input className="sub-detail" type="text" placeholder="Enter Licence Number" />
      </Panel>
      <Panel header="Expiry Date" key="4">
      <DatePicker className="date-picker" onChange={onChange} />
      </Panel>
      <Panel header="Vehicle Class(LMV)" key="5">
      <input className="sub-detail" type="text" placeholder="Enter vehicle class" />
      </Panel>
    </Collapse>
  );
};

export default licenceDetail;
